<div class="whitebg">
    <div class="container">
        <div class="unsubscribecont">
			<img src="{{env.SITE_IMAGE_URL}}tick.png" alt="img" width="150px" />
			<div class="heading">
				<h2>{{'HOME.UNSUBSCRIBED' | translate}}</h2>    
				                  
			</div>
			<p>{{'HOME.UNSUBSCRIBED_BODY' | translate}}</p>

		</div>
    </div>
</div>